import template from './llm-provider-form.html.twig';

const { Component, Mixin } = Shopware;

Component.register('topdata-llm-connect-llm-provider-form', {
    template,

    mixins: [
        Mixin.getByName('notification'),
    ],

    props: {
        entity: {
            type: Object,
            required: true,
        },
        repository: {
            type: Object,
            required: true,
        },
        maskedSecret: {
            type: String,
            default: '',
        },
        showModal: {
            type: Boolean,
            default: true,
        },
    },

    data() {
        return {
            isLoading: false,
            catalog: [],
        };
    },

    computed: {
        isNew() {
            return this.entity.isNew();
        },

        presetOptions() {
            return this.catalog.map((entry) => ({
                value: entry.prefix,
                label: entry.label,
            }));
        },

        selectedProvider() {
            return this.catalog.find((entry) => entry.prefix === this.entity.prefix) ?? null;
        },

        modalTitle() {
            return this.isNew
                ? this.$tc('TopdataLlmConnectSW6.topdata-llm-connect-llm-provider.modalTitleAdd')
                : this.$tc('TopdataLlmConnectSW6.topdata-llm-connect-llm-provider.modalTitleEdit');
        },
    },

    created() {
        this.loadCatalog();
    },

    methods: {
        loadCatalog() {
            Shopware.Service('topdataLlmConnectApiService').getProviderCatalog()
                .then((catalog) => {
                    this.catalog = catalog ?? [];
                })
                .catch(() => {
                    this.catalog = [];
                });
        },

        onSave() {
            if (!this.entity.prefix || !this.entity.prefix.trim()) {
                return;
            }

            if (this.isNew && !this.entity.secretKey) {
                return;
            }

            if (!this.isNew && !this.entity.secretKey) {
                this.entity.secretKey = this.entity.getOrigin().secretKey;
            }

            this.isLoading = true;
            this.repository.save(this.entity).then(() => {
                this.createNotificationSuccess({
                    message: this.$tc('TopdataLlmConnectSW6.topdata-llm-connect-llm-provider.saveSuccess'),
                });
                this.$emit('save', this.entity);
            }).catch(() => {
                this.createNotificationFailure({
                    message: this.$tc('TopdataLlmConnectSW6.topdata-llm-connect-llm-provider.saveError'),
                });
            }).finally(() => {
                this.isLoading = false;
            });
        },

        onCancel() {
            this.$emit('cancel');
        },
    },
});
